export type ECSCpuArch = 'X86_64' | 'ARM64';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isECSCpuArch = (data: any): data is ECSCpuArch => data === 'X86_64' || data === 'ARM64';
